if (!customElements.get('product-detail-tabs')) {
  class ProductDetailTabs extends HTMLElement {
    constructor() {
      super();
      this.mql = window.matchMedia('(min-width: 1024px)');
      this.onMqlChange = this.onMqlChange.bind(this);
    }

    connectedCallback() {
      this.navLinks = [...this.querySelectorAll('[data-nav-link]')];
      this.panels = this.navLinks
        .map((link) => this.querySelector(`[data-block-id="${link.dataset.target}"]`))
        .filter(Boolean);

      this.navLinks.forEach((link) => {
        link.addEventListener('click', this.onNavClick.bind(this));
      });

      this.mql.addEventListener('change', this.onMqlChange);
      this.onMqlChange(this.mql);
    }

    disconnectedCallback() {
      this.mql.removeEventListener('change', this.onMqlChange);
      this.teardownScrollSpy();
    }

    onMqlChange(event) {
      if (event.matches) {
        this.initScrollSpy();
      } else {
        this.teardownScrollSpy();
        this.navLinks.forEach((link) => link.classList.remove('is-active'));
      }
    }

    getScrollOffset() {
      const headerHeight =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--f-header-height')
        ) || 0;
      return headerHeight + 40;
    }

    initScrollSpy() {
      this.teardownScrollSpy();
      if (!this.panels.length) return;

      const offset = this.getScrollOffset();
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const link = this.navLinks.find(
              (item) => item.dataset.target === entry.target.dataset.blockId
            );
            if (link) this.setActiveLink(link);
          });
        },
        { rootMargin: `-${offset}px 0px -65% 0px`, threshold: 0 }
      );

      this.panels.forEach((panel) => this.observer.observe(panel));

      if (this.navLinks.length && !this.navLinks.some((link) => link.classList.contains('is-active'))) {
        this.setActiveLink(this.navLinks[0]);
      }
    }

    teardownScrollSpy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    setActiveLink(link) {
      this.navLinks.forEach((item) => item.classList.remove('is-active'));
      link.classList.add('is-active');
    }

    onNavClick(event) {
      event.preventDefault();
      const link = event.currentTarget;
      const target = this.querySelector(`[data-block-id="${link.dataset.target}"]`);
      if (!target) return;

      const offset = this.getScrollOffset();
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset - 16;
      window.scrollTo({ top, behavior: 'smooth' });
      this.setActiveLink(link);
    }
  }

  customElements.define('product-detail-tabs', ProductDetailTabs);
}
